<template>
  <el-button
    v-inmodule="inmodule"
    :type="type"
    class="TextButton pointer h-auto lh--auto"
    :class="classs"
    link
    plain
    v-bind="$attrs"
    :disabled="disabled"
    @click="toRouter(to)"
  >
    <slot />
  </el-button>
</template>

<script setup>
import { getBusinessPath, getCurrentLocale, localizeUrl } from '@/utils/localeRoute.js'

const route = useRoute()

const props = defineProps({
  type: {
    default: ''
  },
  to: {
    default: '/'
  },
  disabled: {
    default: false
  }
})

const inmodule = $computed(() => {
  const re = /\//
  const path = re.test(props.to) ? props.to : `/${props.to}`
  return path
})

const classs = computed(() => {
  const list = [`c-${props.type}`]

  return list
})

const toRouter = path => {
  const currentLocale = getCurrentLocale({
    path: route.path,
    fallbackLocale: configStore.locale,
  })
  const targetPath = localizeUrl(path, currentLocale)
  if (getBusinessPath(route.path) === getBusinessPath(targetPath)) {
    return
  }
  router.push(targetPath)
}

const configStore = useConfigStore()
</script>

<style lang="scss">
.TextButton {
  padding: 0px !important;
  cursor: pointer;
}
.TextButton + .TextButton {
  margin-left: 0px;
}
</style>
